var _defs, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgAmex = function SvgAmex(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 58.6 37.5",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{fill:#0071ce}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m53.7 33.4-2.6-2.9-2.7 2.9H31.7V19.9h-5.3L33 4.8h6.4l2.3 5.2V4.8h8l1.4 3.9 1.4-3.9h6.1V2.5c0-1.4-1.1-2.5-2.5-2.5H2.5A2.5 2.5 0 0 0 0 2.5V35c0 1.4 1.1 2.5 2.5 2.5h53.6c1.4 0 2.5-1.1 2.5-2.5v-1.6z",
    className: "b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4 31.8h4.2l-5.5-5.9 5.5-5.8h-4.1L51 23.9l-3.4-3.8h-4.2L49 26l-5.6 5.8h4.1L51 28z",
    className: "b"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7 29.1v-1.8h6.6v-2.7h-6.6v-1.8h6.7v-2.7h-9.9v11.7h9.9v-2.7zm18.8-10.7h3V6.6l-4.8.1-2.6 7.3-2.7-7.3h-5v11.7h3.2v-8.2l3 8.2h2.8l3.1-8.2z",
    className: "b"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3 6.7h-4.1L29 18.4h3.5l1-2.3h5.4l1 2.3h3.6zm-3.7 6.7 1.6-3.8 1.6 3.8zm21.1 12.2 2.9 3.2v-6.4z",
    className: "b"
  })));
};
export { SvgAmex as ReactComponent };
export default __webpack_public_path__ + "static/media/amex.78ef3f8556570a2e02c69ddc9625e9d3.svg";